export default __webpack_public_path__ + "static/0203-14f9f0d3fada55a7e616c440fc8e811a.png";